import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { TicketKey } from 'flow/types/EntityKeys';
import { sendPickupQueue } from 'flow/actions/top-actions';
import { selectWaitingQueueItemKeyForTicket } from 'flow/selectors/TicketsSelectors';
import useAppContext from 'flow/hooks/useAppContext';
import MenuItem from 'flow/components/ui-components/MenuItem';

type Props = {
    ticketKey: TicketKey;
};

const MenuItemPickQueueItem = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const waitingQueueItemKey = useAppSelector((state) =>
        selectWaitingQueueItemKeyForTicket(state, ticketKey),
    );

    if (!waitingQueueItemKey) return null;

    const handleClickPickQueueItem = (event?: React.MouseEvent) => {
        event?.stopPropagation();
        dispatch(sendPickupQueue(waitingQueueItemKey, 'AV: ticket item menu'));
    };

    return (
        <MenuItem onClick={handleClickPickQueueItem}>
            <span>{i18next.t('Queue.InQueue.Pick.Title')}</span>
        </MenuItem>
    );
};

export default MenuItemPickQueueItem;
